import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer-user',
  templateUrl: './footer-user.component.html',
  styleUrls: ['./footer-user.component.css'],
})
export class FooterUserComponent {
  checkShowFooter = true;
  currentUrl: string;
  currentDate = new Date()

  constructor(private router: Router, private route: ActivatedRoute) {}
  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        if (this.currentUrl == '/login') {
          this.checkShowFooter = false;
        } else {
          this.checkShowFooter = true;
        }
      }
    });
  }
}
